import { render, staticRenderFns } from "./type-input.vue?vue&type=template&id=07f7d6d6"
import script from "./type-input.vue?vue&type=script&lang=js"
export * from "./type-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports